import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { AutocompleteSearchComponent } from './autocomplete-search/autocomplete-search.component';
import { HourminutesPipe } from './Pipes/hourminutes.pipe';
import { MyDatePickerModule } from 'mydatepicker';

import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';

import { LoginService } from './login/login.service';
import { RegistrationService } from './registration/registration.service';
import { AutocompleteSearchService } from './autocomplete-search/autocomplete-search.service';
import {MatInputModule } from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field'; 
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { FlightSegmentComponent } from './flight-segments/flight-segment.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotPasswordService } from './forgot-password/forgot.service';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SmsLoginComponent } from './sms-login/sms-login.component';
import { GeneralBookingComponent } from './general-booking-detail/general-booking-detail';
import { BookingService } from '../booking/booking-services/booking.service';
import { PointsSliderComponent } from '../booking/home/points-slider/points-slider.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatDatepickerModule } from '@angular/material';
import { SharedDatePickerHeader } from '../common/Utilities/shared-picker-custom-header';

@NgModule({
  declarations: [
    AutocompleteSearchComponent,
    HourminutesPipe,
    LoginComponent,ForgotPasswordComponent,
    RegistrationComponent,FlightSegmentComponent,ResetPasswordComponent,SmsLoginComponent,GeneralBookingComponent,
    PointsSliderComponent,SharedDatePickerHeader
  ],
  imports: [
    CommonModule,
    FormsModule,ReactiveFormsModule,
    TranslateModule,
    MyDatePickerModule    
    ,MatInputModule,MatFormFieldModule,MatAutocompleteModule,NgbModule,NgxSliderModule,MatDatepickerModule,MatInputModule,MatFormFieldModule
  ],
  exports: [
    AutocompleteSearchComponent,
    HourminutesPipe,
    LoginComponent,
    RegistrationComponent,FlightSegmentComponent,
    ForgotPasswordComponent,ResetPasswordComponent,SmsLoginComponent,GeneralBookingComponent,PointsSliderComponent,MatDatepickerModule,MatInputModule,MatFormFieldModule,SharedDatePickerHeader
  ],
  entryComponents:[
    SharedDatePickerHeader
  ],
  providers: [LoginService, RegistrationService, AutocompleteSearchService,ForgotPasswordService,BookingService]
})
export class SharedModule { }
